/**
 * SyndicateDetailPage — redirects to AccountDetailPage (/crm/accounts/:id)
 * AccountDetailPage renders all standard account tabs PLUS an "Ownership" tab
 * when account.is_tenant_managed === true.
 */
import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

export default function SyndicateDetailPage() {
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (id) {
      navigate(`/crm/accounts/${id}`, { replace: true });
    }
  }, [id, navigate]);

  return null;
}
